export default "__VITE_ASSET__YvNRg3Gj__"